import moment from "moment";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import Footer from "../SharePages/Footer/Footer";
import Navbar from "../SharePages/Navbar/Navbar";
import SideNavBar from "../SharePages/SideNavBar/SideNavBar";
import {
  getAllHoldPurposeType,
  getBookingData,
  getHoldBalanceData,
  getsototicketData,
} from "../../common/allApi";
import TableLoader from "../../component/tableLoader";
import NoDataFound from "../../component/noDataFound";
import { MdOutlineSkipPrevious } from "react-icons/md";
import { MdOutlineSkipNext } from "react-icons/md";
import { toast, ToastContainer } from "react-toastify";

const HoldBalance = () => {
  let [pageCount, setPageCount] = useState(0);
  let [pageSize, setPageSize] = useState(10);
  let [currentPageNumber, setCurrentPageNumber] = useState(1);
  let [holdBalanceList, setHoldBalanceList] = useState([]);
  const [holdPurposeType, setHoldPurposeType] = useState([]);
  const [grandTotal, setGrandTotal] = useState({});
  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const [isTimeOut, setIsTimeOut] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsTimeOut(true), 10000);
  }, []);

  useEffect(() => {
    try {
      const getAllHoldPurposeTypeApi = async () => {
        const response = await getAllHoldPurposeType();
        if (response?.data?.data?.isSuccess) {
          setHoldPurposeType(response?.data?.data?.data);
        } else {
          setHoldPurposeType([]);
        }
      };
      getAllHoldPurposeTypeApi();
    } catch (err) {
      toast.error("Please try again..");
    }
  }, []);

  const now = new Date();
  const [sendObj, setSendObj] = useState({
    fromDate: moment(new Date(now.getFullYear(), now.getMonth(), 1)).format(
      "YYYY-MM-DD"
    ),
    toDate: moment(now).format("YYYY-MM-DD"),
    purposeTypeId: "",
    balanceStatus: "All",
    reference: null,
  });

  const [filterData, setfilterData] = useState({
    fromDate: moment(new Date(now.getFullYear(), now.getMonth(), 1)).format(
      "YYYY-MM-DD"
    ),
    toDate: moment(now).format("YYYY-MM-DD"),
    agentId: sessionStorage.getItem("agentId"),
    purposeTypeId: "",
    balanceStatus: "All",
    reference: null,
  });
  useEffect(() => {
    const cleanedObj = Object.fromEntries(
      Object.entries(filterData).filter(([key, value]) => value !== "")
    );
    const getHoldBalanceList = async () => {
      try {
        setLoading(true);
        const response = await getHoldBalanceData(
          {
            ...cleanedObj,
          },
          currentPageNumber,
          pageSize
        );
        setHoldBalanceList(await response?.data?.data?.data);
        setPageCount(await response.data.data?.totalPages);
        setGrandTotal(await response?.data?.data?.grandTotal);
        setLoading(false);
      } catch {
        setLoading(false);
      }
    };
    getHoldBalanceList();
  }, [isSearch, currentPageNumber, pageSize, filterData]);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setCurrentPageNumber(currentPage);
  };

  const handleClear = () => {
    setCurrentPageNumber(1);
    setSendObj({
      fromDate: moment(new Date(now.getFullYear(), now.getMonth(), 1)).format(
        "YYYY-MM-DD"
      ),
      toDate: moment(now).format("YYYY-MM-DD"),
      purposeTypeId: "",
      balanceStatus: "All",
      reference: null,
    });
    setfilterData({
      fromDate: moment(new Date(now.getFullYear(), now.getMonth(), 1)).format(
        "YYYY-MM-DD"
      ),
      toDate: moment(now).format("YYYY-MM-DD"),
      purposeTypeId: "",
      balanceStatus: "All",
      reference: null,
    });
  };

  const [idxD, setIdxD] = useState("SotoTicket");
  let onStatusChange = (statusId) => {
    setIdxD(statusId);
  };
  return (
    <div>
      <Navbar></Navbar>
      <SideNavBar></SideNavBar>
      <div className="content-wrapper search-panel-bg px-4 pb-5">
        <section className="content-header"></section>
        <section className="content">
          <ToastContainer position="bottom-right" autoClose={1500} />
          <form className="mx-lg-5 mx-md-5 mx-sm-1 mt-3">
            <div className="container-fluid bg-white">
              <div className="row">
                <div
                  className="col-lg-12 border-bottom d-flex justify-content-start p-0 ms-2 ms-lg-0"
                  style={{
                    whiteSpace: "nowrap",
                    overflowX: "auto",
                    scrollbarWidth: "none", // For Firefox
                    WebkitOverflowScrolling: "touch", // For smooth scrolling on iOS
                    msOverflowStyle: "none", // For IE and Edge
                  }}
                >
                  <div
                    className={
                      idxD === "SotoTicket"
                        ? "custom-selected-tab px-3 rounded-top fs-6 py-3 fw-bold"
                        : "fs-6 px-3 py-3 fw-bold text-black"
                    }
                    style={{ cursor: "pointer" }}
                    onClick={() => onStatusChange("SotoTicket")}
                  >
                    <span
                      className={
                        idxD === "SotoTicket" &&
                        "custom-border-selected-tab pb-3"
                      }
                    >
                      Hold Balance
                    </span>
                  </div>
                </div>
              </div>

              <div className="row p-2 py-3">
                <div className="container-fluid bg-white">
                  <div className="row my-3">
                    <div className="col-sm-2 mb-3 mb-lg-0">
                      <select
                        value={sendObj?.purposeTypeId}
                        className="form-select border-radius"
                        placeholder="Select Purpose"
                        onChange={(e) =>
                          setSendObj({
                            ...sendObj,
                            purposeTypeId: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Purpose Type</option>
                        {holdPurposeType?.map((item, index) => (
                          <option value={item?.id} key={index}>
                            {item?.description}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-sm-2 mb-3 mb-lg-0">
                      <select
                        value={sendObj?.balanceStatus}
                        className="form-select border-radius"
                        placeholder="Select Type"
                        onChange={(e) =>
                          setSendObj({
                            ...sendObj,
                            balanceStatus: e.target.value,
                          })
                        }
                      >
                        <option value="All" selected>
                          All
                        </option>
                        <option value="Hold"> Hold</option>
                        <option value="Release"> Release</option>
                      </select>
                    </div>
                    <div className="col-sm-2 mb-3 mb-lg-0">
                      <input
                        type={"text"}
                        value={
                          sendObj?.reference === null ? "" : sendObj?.reference
                        }
                        onChange={(e) =>
                          setSendObj({
                            ...sendObj,
                            reference: e.target.value,
                          })
                        }
                        className="form-control border-radius"
                        placeholder="PNR/Invoice No"
                      ></input>
                    </div>

                    <div className="col-sm-2 mb-3 mb-lg-0">
                      <input
                        type={"date"}
                        pattern="\d{4}-\d{2}-\d{2}"
                        max={new Date().toISOString().split("T")[0]}
                        value={sendObj?.fromDate}
                        onChange={(e) =>
                          setSendObj({
                            ...sendObj,
                            fromDate: e.target.value,
                          })
                        }
                        className="form-control border-radius"
                        placeholder="From Date"
                      ></input>
                    </div>
                    <div className="col-sm-2 mb-3 mb-lg-0">
                      <input
                        type={"date"}
                        pattern="\d{4}-\d{2}-\d{2}"
                        max={new Date().toISOString().split("T")[0]}
                        value={sendObj?.toDate}
                        onChange={(e) =>
                          setSendObj({
                            ...sendObj,
                            toDate: e.target.value,
                          })
                        }
                        className="form-control border-radius"
                        placeholder="To Date"
                      ></input>
                    </div>

                    <div className="col-lg-2">
                      <div className="col-sm-12">
                        <button
                          type="button"
                          class="btn button-color fw-bold text-white border-radius filter-btn"
                          onClick={() => {
                            setIsSearch((old) => !old);
                            setCurrentPageNumber(1);
                            setfilterData(sendObj);
                          }}
                        >
                          Apply Filter
                        </button>
                        <button
                          type="button"
                          style={{ backgroundColor: "#ED7F22" }}
                          class="btn  fw-bold text-white border-radius ms-2 filter-btn"
                          onClick={() => handleClear()}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="table-responsive">
                  <table
                    className="table table-lg"
                    style={{ width: "100%", fontSize: "13px" }}
                  >
                    <thead className="text-start fw-bold bg-secondary">
                      <tr>
                        <th>REFERENCE</th>
                        <th>PURPOSE</th>
                        <th>TYPE</th>
                        <th>HOLD DATE</th>
                        <th className="text-end">HOLD AMOUNT</th>
                        <th>RELEASE DATE</th>
                        <th className="text-end">RELEASE AMOUNT</th>
                        <th>REASON</th>
                      </tr>
                    </thead>
                    <tbody className="tbody">
                      {isLoading ? (
                        <tr>
                          <td colSpan="11" style={{ textAlign: "center" }}>
                            <TableLoader />
                          </td>
                        </tr>
                      ) : holdBalanceList.length > 0 ? (
                        holdBalanceList.map((item, index) => {
                          return (
                            <tr
                              key={index}
                              className="text-start fw-bold text-secondary"
                            >
                              <td
                                style={{
                                  color: "#068b9f",
                                  fontWeight: 800,
                                }}
                              >
                                {item.reference}
                              </td>
                              <td>{item?.purpose}</td>
                              <td>
                                {item.status === "Rejected" ? (
                                  <span
                                    style={{
                                      backgroundColor: "#fff4ef",
                                      color: "#e13920",
                                      fontWeight: 600,
                                    }}
                                    className="px-3 py-2 rounded"
                                  >
                                    {item?.status}
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      backgroundColor: "#ecfdf3",
                                      color: "#26a36a",
                                      fontWeight: 600,
                                    }}
                                    className="px-3 py-2 rounded"
                                  >
                                    {item?.status}
                                  </span>
                                )}
                              </td>

                              <td>
                                {item.createdDate != null ? (
                                  moment(item.createdDate).format("DD-MMM-YYYY")
                                ) : (
                                  <></>
                                )}
                              </td>
                              <td className="text-end text-dark">
                                BDT {item?.holdAmount?.toLocaleString("en-US")}
                              </td>
                              <td>
                                {item.releasedDate != null ? (
                                  moment(item.releasedDate).format(
                                    "DD-MMM-YYYY"
                                  )
                                ) : (
                                  <></>
                                )}
                              </td>
                              <td className="text-end text-dark">
                                BDT{" "}
                                {item?.releaseAmount?.toLocaleString("en-US") ??
                                  ""}
                              </td>
                              <td>{item?.reason}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </tbody>
                    <tfoot>
                      {holdBalanceList !== undefined &&
                      holdBalanceList?.length > 0 ? (
                        <>
                          {" "}
                          <tr className="fw-bold">
                            <td colSpan={4} style={{ textAlign: "right" }}>
                              Grand Total (BDT)
                            </td>
                            <td
                              style={{ textAlign: "right" }}
                              className="fw-bold text-end"
                            >
                              BDT{" "}
                              {grandTotal?.totalHoldAmount?.toLocaleString(
                                "en-US"
                              )}
                            </td>
                            <td></td>
                            <td
                              style={{ textAlign: "right" }}
                              className="fw-bold text-end"
                            >
                              BDT{" "}
                              {grandTotal?.totalReleaseAmount?.toLocaleString(
                                "en-US"
                              )}
                            </td>
                            <td></td>
                          </tr>
                        </>
                      ) : (
                        <></>
                      )}
                    </tfoot>
                  </table>

                  {holdBalanceList?.length === 0 && !isLoading && (
                    <NoDataFound />
                  )}
                </div>
                <div className="d-flex justify-content-end">
                  {holdBalanceList?.length > 0 && !isLoading && (
                    <ReactPaginate
                      previousLabel={
                        <div className="d-flex align-items-center gap-1">
                          <MdOutlineSkipPrevious
                            style={{ fontSize: "18px" }}
                            color="#ed8226"
                          />{" "}
                          Prev
                        </div>
                      }
                      nextLabel={
                        <div className="d-flex align-items-center gap-1">
                          <MdOutlineSkipNext
                            style={{ fontSize: "18px" }}
                            color="#ed8226"
                          />
                          Next
                        </div>
                      }
                      breakLabel={"..."}
                      pageCount={pageCount}
                      marginPagesDisplayed={2}
                      forcePage={currentPageNumber - 1}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={
                        "pagination justify-content-center py-2 border rounded"
                      }
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  )}
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default HoldBalance;